<!--
 * @Author: your name
 * @Date: 2022-03-21 09:16:05
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-23 14:54:44
 * @Description: file content
-->
<template>
  <div class="bottom">
    <InfoContainer>
      <template #title>
        <LotteryTitle lottery-title="活动奖品" />
      </template>
      <template #content>
        <LotteryList :values="$store.state.lottery.prizeNames"></LotteryList>
      </template>
    </InfoContainer>
    <InfoContainer>
      <template #title>
        <LotteryTitle lottery-title="活动时间" />
      </template>
      <template #content>
        <LotteryList
          :values="[$store.state.lottery.effectiveEndTime]"
        ></LotteryList>
      </template>
    </InfoContainer>
    <InfoContainer>
      <template #title>
        <LotteryTitle lottery-title="活动说明" />
      </template>
      <template #content>
        <SingleInfo :info="$store.state.lottery.remark"></SingleInfo>
      </template>
    </InfoContainer>
  </div>
</template>

<script>
  import LotteryTitle from "../../components/LotteryTitle";
  import LotteryList from "../../components/LotteryList";
  import InfoContainer from "../../components/InfoContainer";
  import SingleInfo from "../../components/SingleInfo";
  export default {
    components: { LotteryTitle, LotteryList, SingleInfo, InfoContainer },
  };
</script>

<style lang="less" scoped>
  .bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 54px 54px 0 0;
    background: snow;
  }
</style>
